export default "__VITE_ASSET__DRk837u0__"